import React, { useEffect } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import { format, addDays, parseISO } from 'date-fns';

import AirportPicker from '../common/AirportPicker';
import DatePicker from 'react-datepicker';
import SelectInput from '../common/SelectInput';
import CheckboxInput from '../common/CheckboxInput';

import { SEARCH_TYPES, CABIN_CLASSES, SEARCH_COUNTS_LIMITS } from '../constants';

import useApi from './useApi';
import useSearchState from './useSearchState';
import MulticitySelector from './MulticitySelector';

const { ROUNDTRIP, ONEWAY, MULTICITY } = SEARCH_TYPES;

const NOW = new Date();
const TODAY = parseISO(format(addDays(NOW, 0), 'yyyy-MM-dd'));
const TODAYSTRING = format(addDays(NOW, 0), 'yyyy-MM-dd');

const SearchBar = (props) => {
  const { className } = props;
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const departureStation = searchParams.get('departureStation');
  const destinationStation = searchParams.get('destinationStation');

  const { data: { airports }, status } = useApi();
  const departureObj = airports.find(obj => obj.iataCode === departureStation);
  const destinationObj = airports.find(obj => obj.iataCode === destinationStation);
  
  const {
    actions,
    data: { slices, bookingRequest, readyToSubmit, errors }
  } = useSearchState(props,departureObj,destinationObj);

  var TODAYPLUSONE = new Date(bookingRequest.departureDate || TODAY);
  TODAYPLUSONE.setDate(TODAYPLUSONE.getDate() + parseInt(1));
  return (
    <form className={className || 'splash-form'} >
      <div className="tabs-input">
        <input type="radio" className="tab-radio" checked={bookingRequest.tripType === ONEWAY} onChange={() => { }} />
        <label className="tab-label" onClick={() => actions.update('tripType', ONEWAY)}>ذهاب فقط</label>

        <input type="radio" className="tab-radio" checked={bookingRequest.tripType === ROUNDTRIP} onChange={() => { }} />
        <label className="tab-label" onClick={() => actions.update('tripType', ROUNDTRIP)}>ذهاب و عودة</label>

        <input type="radio" className="tab-radio" checked={bookingRequest.tripType === MULTICITY} onChange={() => { }} />
        <label className="tab-label" onClick={() => actions.update('tripType', MULTICITY)}>وجهات متعددة</label>
      </div>

      {bookingRequest.tripType !== MULTICITY && <div>
        <div className="airports">
          <AirportPicker
            value={bookingRequest.departureStation || departureObj}
            placeholder="أين ستبدأ رحلتك"
            airports={airports}
            onChange={(value) => actions.update('departureStation', value)}
          />
          <div className='tooltip'>
            <i
              className='switch spread fa fa-fw fa-xl fa-exchange-alt'
              onClick={actions.switchDirection} >
            </i>
            <span className="bottom-tooltip-text">عكس الإتجاه</span>
          </div>
          <AirportPicker
            value={bookingRequest.destinationStation || destinationObj}
            airports={airports}
            placeholder="اختر وجهتك"
            onChange={(value) => actions.update('destinationStation', value)}
          />
        </div>

        <div className="dates" style={(errors.returnDate || errors.departureDate) && { alignItems: 'baseline' }}>
          <label className='custom-picker'>
            <p>المغادرة</p>
            <DatePicker
              selected={bookingRequest.departureDate}
              onChange={(date) =>
                actions.update('departureDate', date)
              }
              placeholderText={bookingRequest.departureDate || TODAYSTRING}
              minDate={TODAY}
              maxDate={bookingRequest.returnDate}
              dateFormat="yyyy-MM-dd"
              isClearable
              autofocus
            />
          </label>

          {bookingRequest.tripType === ROUNDTRIP && <i className="no-show spread fa fa-fw fa-2x fa-exchange-alt"></i>}
          {bookingRequest.tripType === ROUNDTRIP && <div className='custom-picker'>
            <p>العودة</p>
            <DatePicker selected={bookingRequest.returnDate} onChange={(date) => actions.update('returnDate', date)}
              placeholderText={bookingRequest.returnDate || format(addDays(TODAYPLUSONE, 0), 'yyyy-MM-dd')}
              minDate={TODAYPLUSONE}
              isClearable
              dateFormat="yyyy-MM-dd"
            />
          </div>}
        </div>
      </div>}

      {bookingRequest.tripType === MULTICITY &&
        <MulticitySelector
          slices={slices}
          updateSlices={actions.updateSlices}
          switchDirection={actions.switchDirection}
          airports={airports}
        />
      }

      <div className="buttons">
        <div className="passenger-picker tooltip">
          <i className="fas fa-fw fa-plus-circle" onClick={() => actions.increase('adults')}></i> {bookingRequest.adults} x <i className="fas fa-male" style={{ marginLeft: 4 }}></i> <i className="fas fa-fw fa-minus-circle" onClick={() => actions.decrease('adults')}></i>
          <span className="bottom-tooltip-text">بالغ</span>
        </div>

        <div className="passenger-picker tooltip">
          <i className="fas fa-fw fa-plus-circle" onClick={() => actions.increase('children')}></i> {bookingRequest.children} x <i className="fas fa-child" style={{ marginLeft: 4 }}></i> <i className="fas fa-fw fa-minus-circle" onClick={() => actions.decrease('children')}></i>
          <span className="bottom-tooltip-text">طفل</span>
        </div>

        <div className="passenger-picker tooltip">
          <i className="fas fa-fw fa-plus-circle" onClick={() => actions.increase('infants')}></i> {bookingRequest.infants} x <i className="fas fa-baby" style={{ marginLeft: 4 }}></i>  <i className="fas fa-fw fa-minus-circle" onClick={() => actions.decrease('infants')}></i>
          <span className="bottom-tooltip-text">رضيع</span>
        </div>

        <SelectInput
          title="درجة المقصورة"
          list={CABIN_CLASSES}
          value={bookingRequest.cabinClass}
          onChange={(target) => { actions.update('cabinClass', target); }}
        />

        <div className="spacer"></div>

        <input
          className="button"
          type="submit"
          value={status === 'submitting' ? 'جاري البحث ...' : 'ابحث عن رحلتك'}
          onClick={actions.search}
          disabled={!readyToSubmit && !errors.returnDate && !errors.departureDate}
          style={{ marginRight: '4px' }}
        />

      </div>

    </form>);
};

export default SearchBar;